import type { z } from 'zod';

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export interface Endpoint {
  method: HttpMethod;
  /** Sintaxe Fastify: '/api/<modulo>/<recurso>/:id'. */
  path: string;
  params?: z.ZodObject;
  query?: z.ZodObject;
  body?: z.ZodType;
  /** Forma de `data` no envelope de sucesso. */
  output: z.ZodType;
}

/** Contrato HTTP compartilhado entre `apps/api` (rota) e o front (cliente `fetch` tipado). */
export const defineEndpoint = <const E extends Endpoint>(e: E): E => e;
